var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.ad.status)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"mr-2",attrs:{"small":"","color":_vm.color}},on))]}}],null,false,1374426554)},[_c('span',[_vm._v(" "+_vm._s(_vm.$t(("adStatus." + (_vm.ad.status))))+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }